import type { PaymentTokenStatus } from '@cognitoforms/types/server-types/payment/model/payment-token-status';

/**
 * The minimum order amount (in the form's currency) that Cognito Pay, Stripe, and Square can charge.
 */
export const MINIMUM_PAYMENT_AMOUNT = 1;

export type PaymentTokenInfo = {
	Token: string;
	ClientSecret?: string;
	VerificationToken?: string,
	Status: PaymentTokenStatus,
	SaveForFutureUse?: boolean;
	Type: string;
	DateCreated: Date;
	IsLive: boolean;
	Card: CardInfo;
};

export type CardInfo = {
	Country?: string;
	Brand: string;
	Last4: string;
};

// FormsViewBuilder.RegisterBillingInformationScript()
export type OrderInfo = {
	Name?: NameInfo;
	Address?: AddressInfo;
	Email?: string;
	Phone?: string;
	Amount?: number;
};

// Name.cs
export type NameInfo = {
	First?: string;
	Last?: string;
};

// Address.cs
export type AddressInfo = {
	Line1: string;
	Line2: string;
	City: string;
	State: string;
	PostalCode: string;
	Country: string;
	CountryCode: string;
};

export type PaymentProcessorComponent = {
	createToken(): Promise<PaymentTokenInfo>;
};

export type PaymentProcessorCardComponent = {
	initializeForm(): Promise<any>;
	elementStatus: PaymentFieldStatus;
};

export type PaymentProcessorAuthenticationCompleteEvent = {
	success: boolean;
	token?: string;
	status?: PaymentTokenStatus;
	type?: string;
	clientSecret?: string;
	verificationToken?: string;
	forceSubmit?: boolean;
};

export type PaymentFieldStatus = {
	isEmpty: boolean;
	isComplete: boolean;
	isValid?: boolean;
};

export type PaymentFieldEvent = {
	type: 'focus' | 'blur' | 'change';
	sender: PaymentProcessorComponent;
	originalEvent: any;
	originalSender: PaymentProcessorCardComponent;
};

export type AuthenticationCompleteEvent = {
	success: boolean;
	forceResubmit?: boolean;
};
